/** IndexedDB, not localStorage: synchronous and size-capped is the wrong place
 *  for a clinical note. Cleared on sign-out and on any 401. */
import { openDB, type IDBPDatabase } from 'idb'

const DB_NAME = 'clinic-op-sheet'
const STORE = 'kv'
const VERSION = 1

let dbPromise: Promise<IDBPDatabase> | null = null

function db(): Promise<IDBPDatabase> {
  dbPromise ??= openDB(DB_NAME, VERSION, {
    upgrade(database) {
      if (!database.objectStoreNames.contains(STORE)) database.createObjectStore(STORE)
    },
  })
  return dbPromise
}

export const webStorage = {
  async get<T>(key: string): Promise<T | null> {
    return ((await (await db()).get(STORE, key)) as T | undefined) ?? null
  },
  async set<T>(key: string, value: T): Promise<void> {
    await (await db()).put(STORE, value, key)
  },
  async remove(key: string): Promise<void> {
    await (await db()).delete(STORE, key)
  },
  async keys(prefix: string): Promise<string[]> {
    const all = (await (await db()).getAllKeys(STORE)) as string[]
    return all.filter((k) => typeof k === 'string' && k.startsWith(prefix))
  },
  async clear(): Promise<void> {
    await (await db()).clear(STORE)
  },
}
